module.exports = "pegasus/assets/blocks/column-lp5-themelp1.png";